import { render, staticRenderFns } from "./SetService.vue?vue&type=template&id=1c425068"
import script from "./SetService.vue?vue&type=script&lang=js"
export * from "./SetService.vue?vue&type=script&lang=js"
import style0 from "./SetService.vue?vue&type=style&index=0&id=1c425068&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports